<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-11 15:31:05
 * @FilePath: \gcp-fe\src\app\procurementNotice\views\procurementNotice.vue
 * @Description: 采购公告
-->
<template>
  <div>
    <div class="wrapper">
      <div v-if="isShowBread" style="padding-top: 10px;">
        <base-bread-crumb
          :currBreadCrumb="currBreadCrumb"
          :isShowPortal="false"
        ></base-bread-crumb>
      </div>
      <div class="navBox">
        <div
          v-for="(item, index) in dataJs.tabList"
          :key="index"
          class="navBoxItem"
          :class="{ active: index == active }"
          @click="handleNav(item)"
        >
          <img :src="item.img" alt="" srcset="" />
          <span>{{ item.title }}</span>
        </div>
        <div class="navBoxItem navBoxItems">
          <img src="@/basa/assets/images/gg6.png" alt="" srcset="" />
          <span>工程服务(建设中)</span>
        </div>
      </div>
      <div class="contentBox" v-if="active !== 5">
        <formSearch :active="active"></formSearch>
      </div>
    </div>
  </div>
</template>

<script>
import dataJs from "../js";
import formSearch from "../components/formSearch.vue";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";

export default {
  components: {
    baseBreadCrumb,
    formSearch
  },
  data() {
    return {
      dataJs,
      active: 0,
      currBreadCrumb: [
        { title: "采购公告", path: "/procurementNotice" },
        { title: "公开采购公告", path: "/procurementNotice" },
        { title: sessionStorage.getItem("searchName") }
      ],
      isShowBread: false
    };
  },
  watch: {},
  mounted() {
    if (this.$route.query.type == 4) {
      this.currBreadCrumb[1].title = "中标结果公示";
      this.currBreadCrumb[1].path = "/procurementNotice?type=4";
    }
  },
  activated() {},
  deactivated() {},
  methods: {
    handleNav(row) {
      this.active = row.key - 1;
      if (this.active == 5) {
        this.$message({
          message: "建设中",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return (this.active = 0);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navBox {
  margin-top: 20px;
  background-color: #fff;
  height: 56px;
  line-height: 56px;
  padding: 0 100px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  .navBoxItem {
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      display: inline-block;
      margin-left: 5px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #4a4a4a;
    }
  }

  .navBoxItems {
    cursor: default;
  }

  .active {
    span {
      color: #4393ff;
    }

    border-bottom: 5px solid #4393ff;
  }
}
</style>
